<div *ngIf="model">
  <p (click)="backToMap()" class="back-to-map-button default-color">
    <mat-icon>keyboard_return</mat-icon>{{ "back_to_map" | translate }}
  </p>
  <div class="marker-panel">
    <div class="flexed-panel">
      <div class="flexed-panel-item-70">
        <mat-toolbar class="toolbar-logged">
          <span>{{ "details" | translate }}</span>
        </mat-toolbar>

        <div class="flexed-panel">

          <div class="flexed-panel-item-40">
            <p>
              <b>{{ "year-of-build-preview" | translate }}: </b>
              {{ transformDate(model.construction) }}
            </p>
            <p>
              <b>{{ "municipality" | translate }}:</b>
              {{ model.municipality?.name }}
            </p>
            <p>
              <b>{{ 'street' | translate }}: </b>
              {{ model.details ? model.street: "" }}
            </p>
            <p>
              <b>{{ 'street-number' | translate }}: </b>
              {{ model.details ? model.streetNumber : "" }}
            </p>
            <p>
              <b>{{ "floors" | translate }}: </b>
              {{ model.details ? model.details.floors : "" }}
            </p>
            <p>
              <b>{{ "number-apartments" | translate }}: </b>
              {{ model.details ? model.details.apartments : 0 }}
            </p>

          </div>

          <div class="flexed-panel-item-40">
            <p>
              <b>{{ "apartmentsForRent" | translate }}: </b>
              {{ model.details ? model.details.apartmentsForRent : "" }}
            </p>
            <p>
              <b>{{ "partInPercentage" | translate }}: </b>
              {{ model.details ? model.details.partInPercentage : "" }}
            </p>
            <p>
              <b>{{ "year-renovation" | translate }}: </b>
              {{ model.details ? model.details.lastYearRenovation : "" }}
            </p>
            <p>
              <b>{{ "longitude" | translate }}: </b>
              {{ model.details ? model.longitude : "" }}
            </p>
            <p>
              <b>{{ 'latitude' | translate }}: </b>
              {{ model.details ? model.latitude : "" }}
            </p>
          </div>
        </div>

        <mat-divider></mat-divider>

        <app-manage-building [validCategories]="validCategories" [type]="manageBuildingTypes.Details"
          [modelId]="model.id"></app-manage-building>
      </div>

      <div class="flexed-panel-item-30">
        <mat-toolbar class="toolbar-logged">
          <span>{{ "map" | translate }}</span>
        </mat-toolbar>
        <app-buildings-map [mapMode]="singleMarker" [markerModel]="model" [showDashboard]="false"></app-buildings-map>
      </div>
    </div>
    <div class="flexed-panel"></div>
  </div>
</div>
